module.exports = __webpack_public_path__ + "media/aboutUsVideo.0943e628.mp4";